<template>
    <div class="task-menu"  :class="{ open: openState}">
        <modal class="throw-lease" :display="modalState.throwLease" @modalStatus="closeModal('throwLease')" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>退租點交</h1>
            <div class="content">
                確定要退租點交“{{throwLease.name}}”的合約嗎？確定後將通知房客退租點交
            </div>
            <div class="btn-group">
                <button class="default-button" @click="setThrowLease(), $analyticsBiz.logEvent('退租點交', { screen_name: '退租點交'})">確認</button>
                <button class="border-button" @click="closeModal('throwLease')">取消</button>
            </div>
        </modal>
        <new-bill :cid="contractId"></new-bill>
        <div class="wrap">
            <div class="info">
                <!-- <div class="more" v-if="taskHouseInfo.empty == 0">
                    <task-dot-drop-menu>
                        <ul >
                            <router-link  :to="{ name: 'NewTask', query: { hid: taskHouseInfo.housesCid }}">
                                <li>新增委託</li>
                            </router-link>
                            <li @click="setNewBill(), contractId = taskHouseInfo.contractCid, $analyticsBiz.logEvent('新增費用', { screen_name: '新增費用'})">新增費用</li>
                            <li @click="modalState.throwLease = true,throwLease.contractCid = taskHouseInfo.contractCid,throwLease.name = taskHouseInfo.name">退租點交</li>
                        </ul>
                    </task-dot-drop-menu>
                </div>
                <div class="more" v-if="taskHouseInfo.empty == 1 && !isBooking">
                    <task-dot-drop-menu>
                        <ul >
                            <router-link :to="{ name: 'NewTask', query: { hid: taskHouseInfo.housesCid }}">
                                <li>新增委託</li>
                            </router-link>
                        </ul>
                    </task-dot-drop-menu>
                </div>
                <div v-if="taskHouseInfo.empty == 0 && taskHouseInfo.contractType == 'ELECTRONIC_CONTRACT'" @click="getContract(taskHouseInfo.contractCid),$analyticsBiz.logEvent('查看電子合約')" class="contract-info">
                    <img src="@/assets/img/icon/recently_white.svg" alt="">
                    <div>合約</div>
                </div>
                <div v-else-if="taskHouseInfo.empty == 0 && taskHouseInfo.contractType == 'PAPER_CONTRACT'" @click="getContractPDF(taskHouseInfo.contractCid),$analyticsBiz.logEvent('查看紙本合約')" class="contract-info">
                    <img src="@/assets/img/icon/recently_white.svg" alt="">
                    <div>合約</div>
                </div> -->
                <!-- {{taskHouseInfo}} -->
                <span class="title">{{taskHouseInfo.name}}</span>
                <span class="address">
                    <img src="@/assets/img/icon/address_green.svg" alt="">
                    {{taskHouseInfo.address}}
                </span>
                <span class="status">
                    <img src="@/assets/img/icon/home_white.svg" alt="">
                    {{isEmpty}}{{day}}
                </span>
                <div class="tanant" v-show="this.taskHouseInfo.empty == '0'">
                    <img src="@/assets/img/icon/tanant_white.svg" alt="">
                    {{tanant}}
                </div>
            </div>
            <div class="todo" >
                <todo-block refs="todo" v-for="(state, index) in todoStatus" :key="index+ Math.floor(Math.random()*1000)+1" @todoState="setTodoState" :todoState="state" :houseInfo="taskHouseInfo"></todo-block>
                <todo-block :key="componentKey" refs="todo" v-if="unEvaluation == 7" @todoState="setTodoState" :todoState="unEvaluation" :houseInfo="taskHouseInfo"></todo-block>
                <div v-if="!hasTodo && unEvaluation != 7" class="no-result">
                    <img src="@/assets/img/icon/no_status.svg" alt="">
                    <div>待辦事項清空囉</div>
                </div>
            </div>
            <!-- <div class="todo">
                <todo-block refs="todo" @todoState="setTodoState" :todoState="4" :houseCid="taskHouseInfo.housesCid"></todo-block>
            </div> -->
        </div>        
        <span class="close" @click="taskClose">
            <img src="@/assets/img/icon/cross_white.svg" alt="">
        </span>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import TodoBlock from '@/components/bussiness/widges/tools/TodoBlock.vue';
import TaskDotDropMenu from '@/components/widge/TaskDotDropMenu.vue';
import newBill from '@/components/widge/newBill.vue';

import { 
    apiBizContractThrowLease,
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            openState: this.isOpen,
            componentKey: 0,
            contractId: null,
            modalState: {
                throwLease: false
            },
            throwLease: {
                contractCid: null,
                name: null,
            },
            // taskMenuHeight: '',
            // taskMenuTop: '0'
        }
    },
    props: {
        isOpen: Boolean,
        taskHouseInfo: Object
    },
    mounted() {
        // window.addEventListener('scroll', () => {
        //     let scrollTop = document.documentElement.scrollTop ||
        //                     document.body.scrollTop ||
        //                     document.querySelector('.element').scrollTop;
            
        //     this.taskMenuTop = scrollTop
        // }, true);
        // this.taskMenuHeight = window.innerHeight
        // console.log(document.body.scrollHeight)
    },
    watch: {
        isOpen: function  (val) {
            console.log(val)
            this.openState = val
        },
        taskHouseInfo: function () {
            this.componentKey += 1
        },
        
        
        // taskHouseInfo: {
        //     handler: function () {
        //         console.log(taskHouseInfo.status)
        //         for (let i = 0; i < taskHouseInfo.status.length; i++) {
        //             const state = taskHouseInfo.status[i];
                    
        //             if( state == 0 ){
        //                 console.log('0')
        //             }else if( state == 1 ){
        //                 console.log('1')
        //             }else if( state == 2 ){
        //                 console.log('2')
        //             }else if( state == 3 ){
        //                 console.log('3')
        //             }else if( state == 4 ){
        //                 console.log('4')
        //             }else if( state == 5 ){
        //                 console.log('5')
        //             }else if( state == 6 ){
        //                 console.log('6')
        //             }else if( state == 7 ){
        //                 console.log('7')
        //             }
        //         }
                
        //     },
        //     deep: true
        // } 
    },
    computed: {
        isBooking: function () {
            if(this.taskHouseInfo.status.includes(1)){
                return true
            }else{
                return false
            }
        },
        isEmpty: function () {
            if( this.taskHouseInfo.empty == '1'){
                return '空房'
            }else{
                return '已租'
            }
        },
        day: function () {
            if( this.taskHouseInfo.empty == '1'){
                return `・空 ${this.taskHouseInfo.emptyDay} 天`
            }else{
                if( this.taskHouseInfo.leaveDay < 30){
                    return `・合約到期剩下 ${this.taskHouseInfo.leaveDay} 天`
                }else{
                    return ''
                }
            }
        },
        tanant: function () {
            if( this.taskHouseInfo.empty == '0'){
                return `租客 - ${this.taskHouseInfo.tenantName}`
            }
        },
        unEvaluation: function () {
            if(this.taskHouseInfo.notRateTenant != undefined){
                if(this.taskHouseInfo.notRateTenant.length > 0){
                    return 7
                }else{
                    return
                }
            }
        },
        todoStatus: function () {
            let allowStatus = this.$store.getters.DEFAULT_FILTER_STATUS
            if(this.taskHouseInfo.status != undefined){
                return this.taskHouseInfo.status.filter( state => {
                    if(state != 0 && state != 5 && allowStatus.includes(state)){
                        // console.log(state)
                        return state
                    }
                })
            }
            
        },
        hasTodo: function () {
            let status = this.taskHouseInfo.status
            if(status != undefined){
                if(status.includes(1) || status.includes(2) || status.includes(3) || status.includes(4)){
                    return true
                }else{
                    return false
                }
            }
            
        }
        
    },
    methods: {
        taskClose: function () {
            this.$emit('taskClose', false);
        },
        setTodoState: function (state) {
            for (let i = 0; i < this.$children.length; i++) {
                const todo = this.$children[i];
                if( todo._uid == state.uid ){
                    todo.isOpen = state.state
                }else{
                    todo.isOpen = false
                }
                
            }
        },
        setThrowLease: function () {
            let data = this.throwLease.contractCid
            console.log(data)
            apiBizContractThrowLease(data)
            .then(res => {
                console.log(res)
                if(res.data.status = "SUCCESS"){
                    this.modalState.throwLease = false
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        closeModal: function (type) {
            if( type == 'throwLease' ){
                this.modalState.throwLease = false
            }
        },
        setNewBill: function () {
            this.$store.dispatch('setModalStatus', {state: true, type: 'newBill'})
        },
        getContract: function (cid) {
            window.open('/contractPaper?cid='+cid, "_blank")
        },
    },
    components: {
        TodoBlock,
        TaskDotDropMenu,
        Modal,
        newBill
    }
}
</script>
<style  lang="scss">
    .task-menu{
        position: fixed;
        width: 425px;
        height: 100%;
        padding: 40px 24px;
        top: 0;
        right: -506px;
        background-color: #ff9275;
        transition: all 1s ease-in-out;
        z-index: 9999;
        .wrap{
            span{
                display: block;
            }
            .info{
                margin-bottom: 40px;
                .more{
                    position: absolute;
                    width: 30px;
                    height: 30px;
                    right: 30px;
                    cursor: pointer;
                    border-radius: 4px;
                }
                .contract-info{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    position: absolute;
                    right: 24px;
                    top: 104px;
                    width: 70px;
                    height: 70px;
                    border-radius: 10px;
                    background-color: rgba(255, 255, 255, 0.2);
                    cursor: pointer;
                    img{
                        width: 22px;
                        margin-bottom: 9px;
                    }
                    >div{
                        font-size: 12px;
                        font-weight: 500;
                        color: #fff;
                    }
                }
                .title{
                    font-size: 28px;
                    font-weight: 500;
                    margin-bottom: 20px;
                    color: #ffffff;
                }
                .address,
                .status,
                .tanant{
                    display: flex;
                    align-items: center;
                    color: #ffffff;
                    font-weight: 300;
                    margin-bottom: 16px;
                    img{
                    // width: 13px;
                    // height: 16px;
                        margin-right: 9px; 
                    }
                }
                .tanant{
                    font-weight: 500;
                }
            }
            .todo{
                .no-result{
                    display: flex;
                    align-content: center;
                    justify-content: center;
                    flex-direction: column;
                    font-size: 20px;
                    font-weight: 500;
                    height: 314px;
                    color: #fff;
                    img{
                        width: 30px;
                        margin: 0 auto;
                        margin-bottom: 20px;
                    }
                    >div{
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }
            }
        }
        .close{
            position: absolute;
            width: 30px;
            height: 44px;
            background-color: #676362;
            border-radius: 10px 0 0 10px;
            left: -30px;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                cursor: pointer;
            }
        }
        #modal.throw-lease{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #a8a5a4;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
    }
    .task-menu.open{
        right: 0px;
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/menu/bizTaskMenu.vue